import '../scss/base.scss';
import '../scss/mobile.scss';
import * as main from './main';
import art from '../views/art-m';

(function () {
    main.init();
    art.render();
})();